// extracted by mini-css-extract-plugin
export default {"customedCheckbox":"toggleButton_customedCheckbox__iQk+P","container":"toggleButton_container__4OiRV"};